module.exports = __webpack_public_path__ + "static/media/foto1.e59e947a.png";